import { Flexbox } from '@components/styles/mixins/Flexbox.styled';
import styled from 'styled-components';

export const BottomSheetHeader = styled.header`
    ${Flexbox({ justifyContent: "space-between", alignItems: "center", flexDirection: "row" })}
    padding: 0.5rem 1rem;
    .form-header{
        font-weight:${({ theme }) => theme.fontWeights.regular};
        color:${({ theme }) => theme.colors.emerald30};
        font-size:1.5rem;
    }
    img{
        cursor:pointer;
        height:1.5rem;
    }
`;

export const BForm = styled.form`
    padding:1rem;
`
